<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><img alt="" src="OEBPS/images/logo1.png"/><br/><br/></p>
<p class="center"><span class="big">Orphan<br/><br/>at My Door</span><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/1-2.png"/><br/><br/><br/><br/></p>
<p class="center">The Home Child Diary <br/>of Victoria Cope<br/><br/></p>
<p class="center">B<span class="small">Y</span> J<span class="small">EAN</span> L<span class="small">ITTLE</span><br/><br/><br/><br/></p>
<p class="center">Scholastic Canada Ltd.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3bbd0c1e